<template>
  <div class="product-recommended">
    <div class="pt-5">
      <div class="text-md-h6 text-uppercase primary--text">
        {{ title }}
      </div>
    </div>
    <div class="pt-4 pb-5" v-if="product.length > 0">
      <carousel
        :loop="false"
        :responsive="{ 0: { items: 2 }, 600: { items: 4 }, 1000: { items: 6 } }"
        :nav="false"
        :dots="false"
        :margin="5"
      >
        <div class="pa-1" v-for="(item, index) in product" :key="index">
          <v-hover v-slot:default="{ hover }">
            <template v-if="type == 'displayrecommended'">
              <a
                :href="uri + `/product/${item.product_id}`"
                class="text-deco"
              >
                <v-card
                  outlined
                  class="rounded-lg"
                  :elevation="hover ? 4 : 0"
                  style="position: relative"
                >
                  <div class="pa-3">
                    <v-img :src="item.product_image ? item.product_image : '/assets/product/default.png'" height="150" class="rounded-lg"></v-img>
                  </div>
                  <v-col class="grey--text text--darken-2 px-2">
                    <div class="text-body-2 product-name">
                      {{ item.product_name }}
                    </div>
                    <!-- <div class="product-price mt-2">
                      <div class="text-decoration-line-through font-size-12 pink--text" v-if="item.product_price != item.product_price_origin">Rp {{item.product_price_origin | toNumber}}</div>
                      <div class="text-subtitle-1 pt-1 font-weight-bold">Rp {{item.product_price | toNumber}}</div>
                    </div> -->
                    <!--<div>
                      <v-icon small color="yellow darken-1" v-for="i in 5" :key="i+'itemStar'+item.product_id">mdi-star</v-icon>
                      <span class="pl-1 text-caption">({{item.product_view_count | toNumber}})</span>
                    </div>-->
                    <div v-if="false">
                      <v-icon
                        small
                        color="yellow darken-1"
                        v-for="i in fullRating(item.product_rating)"
                        :key="'full' + i"
                        >mdi-star</v-icon
                      >
                      <v-icon
                        small
                        color="yellow darken-1"
                        v-if="
                          halfRating(
                            item.product_rating,
                            item.product_review_count
                          )
                        "
                        >mdi-star-half-full</v-icon
                      >
                      <v-icon
                        small
                        color="yellow darken-1"
                        v-for="i in nullRating(item.product_rating)"
                        :key="'half' + i"
                        >mdi-star-outline</v-icon
                      >
                      <!-- <v-rating empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half-full" hover length="5" readonly size="12" color="yellow darken-1" :value="parseInt(product.product_rating) / parseInt(product.product_review_count)"></v-rating> -->
                      <span class="pl-1 text-caption"
                        >({{ item.product_review_count | toNumber }})</span
                      >
                    </div>
                    <!-- <div class="text-caption">
                      {{ item.product_sold_count | toNumber }} terjual
                    </div> -->
                  </v-col>
                </v-card>
              </a>
            </template>

            <template v-else>
              <a
                :href="uri + `/${slug}/product/${item.store_product_id}`"
                class="text-deco"
              >
                <v-card
                  outlined
                  class="rounded-lg"
                  :elevation="hover ? 4 : 0"
                  @click="toProductDetail('product-store-detail', item.store_product_id)"
                  style="position: relative;"
                >
                  <v-chip
										close-icon="mdi-close-outline"
										color="red"
										x-small
										style="height: 20px; position: absolute; z-index: 99; right: 10px; top: 10px; display: inline-block; color: white; font-weight: bold; margin-bottom: 1rem;"
										v-if="item.store_product_stock_balance == 0"
									>
										<v-avatar left class="mr-0">
											<v-icon dense x-small>mdi-alert-circle-outline</v-icon>
										</v-avatar>

										KOSONG
									</v-chip>
                  <div class="pa-3">
                    <v-img :src="item.store_product_product_image ? item.store_product_product_image : '/assets/product/default.png'" height="150" class="rounded-lg"></v-img>
                  </div>
                  <v-col class="grey--text text--darken-2 px-2">
                    <div class="text-body-2 product-name">
                      {{ item.product_name }}
                    </div>
                      <template v-if="store.store_free_delivery == 'Ya'">
                        <div class="product-price mt-2">
                          <template v-if="item.product_is_complement == 'Ya'">Rp {{item.store_product_product_price | toNumber}}</template>
                          <template v-else>Rp {{item.store_product_product_price_margin | toNumber}}</template>
                        </div>
											</template>
                    <!-- <div class="product-price mt-2">
                      <div class="text-decoration-line-through font-size-12 pink--text" v-if="item.product_price != item.product_price_origin">Rp {{item.product_price_origin | toNumber}}</div>
                      <div class="text-subtitle-1 pt-1 font-weight-bold">Rp {{item.product_price | toNumber}}</div>
                    </div> -->
                    <!--<div>
                      <v-icon small color="yellow darken-1" v-for="i in 5" :key="i+'itemStar'+item.product_id">mdi-star</v-icon>
                      <span class="pl-1 text-caption">({{item.product_view_count | toNumber}})</span>
                    </div>-->
                    <div v-if="false">
                      <v-icon
                        small
                        color="yellow darken-1"
                        v-for="i in fullRating(item.product_rating)"
                        :key="'full' + i"
                        >mdi-star</v-icon
                      >
                      <v-icon
                        small
                        color="yellow darken-1"
                        v-if="
                          halfRating(
                            item.product_rating,
                            item.product_review_count
                          )
                        "
                        >mdi-star-half-full</v-icon
                      >
                      <v-icon
                        small
                        color="yellow darken-1"
                        v-for="i in nullRating(item.product_rating)"
                        :key="'half' + i"
                        >mdi-star-outline</v-icon
                      >
                      <!-- <v-rating empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half-full" hover length="5" readonly size="12" color="yellow darken-1" :value="parseInt(product.product_rating) / parseInt(product.product_review_count)"></v-rating> -->
                      <span class="pl-1 text-caption"
                        >({{ item.product_review_count | toNumber }})</span
                      >
                    </div>
                    <!-- <div class="text-caption">
                      {{ item.product_sold_count | toNumber }} terjual
                    </div> -->
                  </v-col>
                </v-card>
              </a>
            </template>
          </v-hover>
        </div>
        <template slot="prev">
          <v-card elevation="0" class="col-12 pa-0">
            <v-btn
              x-small
              color="white"
              elevation="3"
              fab
              class="prev prev-other-product"
              ><v-icon color="grey darken-1">mdi-chevron-left</v-icon></v-btn
            >
          </v-card>
        </template>
        <template slot="next">
          <v-card elevation="0" class="col-12 pa-0">
            <v-btn
              x-small
              color="white"
              elevation="3"
              fab
              class="next next-other-product"
              ><v-icon color="grey darken-1">mdi-chevron-right</v-icon></v-btn
            >
          </v-card>
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: {
    carousel,
  },
  computed: {
    title() {
      switch (this.type) {
        case "recommended":
          return "REKOMENDASI PRODUK LAINNYA";
        
        case "displayrecommended":
          return "REKOMENDASI PRODUK LAINNYA";

        case "byStore":
          return "PRODUK LAINNYA DI TOKO INI";

        default:
          return "PRODUK TERBAIK";
      }
    },
  },
  props: {
    type: String,
    product: Array,
    slug: String,
    store: Object
  },

  data() {
    return {
      uri: window.location.origin
    }
  },

  methods: {
    toProductDetail(path, id) {
      // this.$router.push({name: path, params: { id: id}})
      // window.location.replace(window.location.origin + `/${this.slug}/product/${id}`)
      window.location.href = window.location.origin + `/${this.slug}/product/${id}`
    }
  },
};
</script>
